import React, { useState } from "react";
import { Form, Button, Spin } from "antd";
import moment from "moment";
import RenderFilterFields from "./RenderFilterFields";
import { useCallingKpi } from "./store/calingKpiStore";

const CallingKpiFilter = ({
  filterData,
  onApplyFilters,
  initialCallDate,
  queryParam,
  setQueryParam,
  setCurrentPage,
  setPageSize,
  setTriggerFetch,
}) => {
  const [form] = Form.useForm();
  const { filterDataLoading } = useCallingKpi();
  const [dateRangeError, setDateRangeError] = useState(false);
  const [dateRangeErrorMessage, setDateRangeErrorMessage] = useState("");

  const handleFieldChange = (fieldCode, value) => {
    form.setFieldsValue({ [fieldCode]: value });
  };

  const handleFinish = (values) => {
    if (!values.callDate) {
      setDateRangeErrorMessage('Please fill Date')
      setDateRangeError(true);
      return;
    }
    const date = moment(values.callDate).format('YYYY-MM-DD');

    const queryParam = {
      agentUserId: values.agentUserId,
      agentRmUserId: values.agentRmUserId,
      process: values.process,
      callDate: [date, date],
      team: values.team,
      location: values.location,
      house: values.house,
    };

    onApplyFilters(queryParam);
  };

  const handleClear = () => {
    form.resetFields();
    const initialQueryParam = {
      pageSize: 10,
      pageNumber: 1,
      agentUserId: "",
      agentRmUserId: "",
      process: "",
      callDate: initialCallDate,
      team: "",
      location: null,
      house: null,
    };
    setDateRangeErrorMessage('')
    setDateRangeError(false);
    setQueryParam(initialQueryParam);
    setTriggerFetch(true);
    setCurrentPage(1);
    setPageSize(10);
  };

  return (
    <Spin spinning={filterDataLoading}>
      <Form layout="inline" className="my-2" onFinish={handleFinish} form={form}>
        <RenderFilterFields
          date={queryParam.callDate[0]}
          filtersData={filterData}
          onFieldChange={handleFieldChange}
          dateRangeError={dateRangeError}
          setDateRangeError={setDateRangeError}
          dateRangeErrorMessage={dateRangeErrorMessage}
          setDateRangeErrorMessage={setDateRangeErrorMessage}
        />

        <div className="d-flex gap-2">
          <Button type="primary" htmlType="submit">
            Submit
          </Button>
          <Button onClick={handleClear}>Clear</Button>
        </div>
      </Form>
    </Spin>
  );
};

export default CallingKpiFilter;
